import Default from '@app/constants';
import { FilterBatteryLogs } from '@app/typings/services/winnonie/logs';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const filterBatteryLogs: string = 'winnonie/batteryLogs.filters';

export const setFilterBatteryLogsWinnonie = (value: FilterBatteryLogs) => {
  set(filterBatteryLogs, value);
};
export const getFilterBatteryLogsWinnonie = (): FilterBatteryLogs => {
  return (
    get(filterBatteryLogs) || { filters: Default.filter.winnonie.batteryLogs, pages: Default.pages }
  );
};

export const clearFilterBatteryLogsWinnonie = () => {
  return set(filterBatteryLogs, {
    filters: Default.filter.winnonie.batteryLogs,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterBatteryLogsWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
